import React from 'react';

interface StudioBlockEditorContextType {
  // Opens a Studio block's settings (by its canvas card's id) where it is.
  // Absent outside a dashboard or report, where it's edited in Studio.
  openBlockEditor?: (blockId: string) => void;
}

// Kept apart from its provider, which loads Studio's settings, so a block's
// menu can ask for them without importing them
const StudioBlockEditorContext =
  React.createContext<StudioBlockEditorContextType>({});

export default StudioBlockEditorContext;
